import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Login from "../pages/AdminAuth/Login";
import ForgotPassword from "../pages/AdminAuth/ForgotPassword";
import OtpVerify from "../pages/AdminAuth/OtpVerify";
import ResetPassword from "../pages/AdminAuth/ResetPassword";
import ChangeTemporaryPassword from "../pages/AdminAuth/ChangeTemporaryPassword";
import EmployeeOnboarding from "../pages/AdminAuth/EmployeeOnboarding";
import WaitingApproval from "../pages/AdminAuth/WaitingApproval";
import ApprovalRejected from "../pages/AdminAuth/ApprovalRejected";
import {
  AUTH_STATE_EVENT,
  getAuthFlow,
  getAuthToken,
  getAuthUser,
  getDashboardAccess,
  getCurrentDashboard,
  hasPermission,
  clearAllAuthState,
  isAuthSessionValid,
} from "../pages/AdminAuth/components/authStore";

import DashboardLayout from "../pages/Dashboard/DashboardLayout";
import DashboardHome from "../pages/Dashboard/Home/DashboardHome";
import ManageRoles from "../pages/Dashboard/Roles/ManageRoles";
import EmployeeDetails from "../pages/Dashboard/Employees/EmployeeDetails";
import EmployeeProfile from "../pages/Dashboard/Employees/EmployeeProfile";
import AddNewEmployee from "../pages/Dashboard/Employees/AddNewEmployee";
import AddNewRole from "../pages/Dashboard/Roles/AddNewRole";
import WarehouseDetails from "../pages/Dashboard/Warehouse/WarehouseDetails";
import AddNewWarehouse from "../pages/Dashboard/Warehouse/AddNewWarehouse";
import WarehouseView from "../pages/Dashboard/Warehouse/WarehouseView";
import ProductsList from "../pages/Dashboard/Products/ProductsList";
import AddProduct from "../pages/Dashboard/Products/AddProduct";
import AdminInventory from "../pages/Dashboard/Inventory/AdminInventory";
import WarehouseLayout from "../pages/WarehousePanel/WarehouseLayout";
import WarehouseDashboardHome from "../pages/WarehousePanel/Dashboard/WarehouseDashboardHome";
import WarehouseEmployees from "../pages/WarehousePanel/Employees/WarehouseEmployees";
import WarehouseProducts from "../pages/WarehousePanel/Products/WarehouseProducts";
import WarehouseInventory from "../pages/WarehousePanel/Inventory/WarehouseInventory";
import AdminCatalogImport from "../pages/Dashboard/Inventory/AdminCatalogImport";
import SelectDashboard from "../pages/AdminAuth/SelectDashboard";
import Profile from "../pages/Dashboard/Profile";
import AdminPricing from "../pages/Dashboard/Products/AdminPricing";
import PurchaseHistoryPage from "../pages/Dashboard/Products/PurchaseHistoryPage";
import DeliveryPartners from "../pages/Dashboard/DeliveryPartners/DeliveryPartners";
import EmailTemplates from "../pages/Dashboard/EmailTemplates/EmailTemplates";
import ProductDetailsPage from "../pages/Dashboard/Products/ProductDetailsPage";
import WarehouseProductDetailsPage from "../pages/WarehousePanel/Products/WarehouseProductDetailsPage";
import InventoryProductDetailsPage from "../pages/WarehousePanel/Inventory/InventoryProductDetailsPage";
import WarehouseCustomerOrders from "../pages/WarehousePanel/Orders/WarehouseCustomerOrders";
import NotificationsPage from "../pages/Dashboard/Notifications/NotificationsPage";
import SettingsPage from "../pages/Dashboard/Settings/SettingsPage";
import DeliveryPartnerProfile from "../pages/Dashboard/DeliveryPartners/DeliveryPartnerProfile";
import ActivityLogsPage from "../pages/Dashboard/ActivityLogs/ActivityLogsPage";
import UserDetails from "../pages/Dashboard/Users/UserDetails";
import UserForm from "../pages/Dashboard/Users/UserForm";
import PostersPage from "../pages/Dashboard/Posters/PostersPage";
import ShortVideosPage from "../pages/Dashboard/ShortVideos/ShortVideosPage";
import WarehouseStockPage from "../pages/WarehousePanel/Inventory/WarehouseStockPage";
import WarehouseInboundReceiptsPage from "../pages/WarehousePanel/Inventory/WarehouseInboundReceiptsPage";
import BroadcastMessagesPage from "../pages/Dashboard/Broadcasts/BroadcastMessagesPage";
import DriverWalletPage from "../pages/Dashboard/DriverWallet/DriverWalletPage";
import WarehouseNotificationsPage from "../pages/WarehousePanel/Notifications/WarehouseNotificationsPage";
import WarehouseSalesAnalytics from "../pages/WarehousePanel/SalesAnalytics/WarehouseSalesAnalytics";
import ReportsDashboard from "../pages/Dashboard/Reports/ReportsDashboard";
import PaymentCollectionsPage from "../pages/PaymentCollections/PaymentCollectionsPage";
import AdminStockPage from "../pages/Dashboard/Inventory/AdminStockPage";
import AppLayoutManager from "../pages/Dashboard/AppLayout/AppLayoutManager";
import ImageManagerPage from "../pages/Dashboard/ImageManager/ImageManagerPage"; // <-- add
import CouponsPage from "../pages/Dashboard/Coupons/CouponsPage";


import FoodAdminLayout from "../pages/FoodAdminPanel/FoodAdminLayout";
import FoodOverview from "../pages/FoodAdminPanel/FoodOverview";
import FoodRestaurantsPage from "../pages/FoodAdminPanel/FoodRestaurantsPage";
import FoodRestaurantDetailsPage from "../pages/FoodAdminPanel/FoodRestaurantDetailsPage";
import FoodEmployeesPage from "../pages/FoodAdminPanel/FoodEmployeesPage";
import FoodApprovalsPage from "../pages/FoodAdminPanel/FoodApprovalsPage";
import FoodOrdersPage from "../pages/FoodAdminPanel/FoodOrdersPage";
import FoodCouponsPage from "../pages/FoodAdminPanel/FoodCouponsPage";
import FoodReportsPage from "../pages/FoodAdminPanel/FoodReportsPage";
import FoodSettingsPage from "../pages/FoodAdminPanel/FoodSettingsPage";
import FoodItemsPage from "../pages/FoodAdminPanel/FoodItemsPage";
import FoodItemDetailsPage from "../pages/FoodAdminPanel/FoodItemDetailsPage";
import FoodAddItem from "../pages/FoodAdminPanel/FoodAddItem";
import UserNotificationsPage from "../pages/Dashboard/UserNotifications/UserNotificationsPage";
import SupportInbox from "../pages/Dashboard/Support/SupportInbox";
import FoodNotificationsPage from "../pages/FoodAdminPanel/FoodNotificationsPage";

function CurrentDashboardLayout() {
  return getCurrentDashboard() === "warehouse" ? <WarehouseLayout /> : <DashboardLayout />;
}

function CurrentDashboardHome() {
  return getCurrentDashboard() === "warehouse" ? <WarehouseDashboardHome /> : <DashboardHome />;
}

function CurrentEmployeesPage() {
  return getCurrentDashboard() === "warehouse" ? <WarehouseEmployees /> : <EmployeeDetails />;
}

function CurrentProductsPage() {
  return getCurrentDashboard() === "warehouse" ? <WarehouseProducts /> : <ProductsList />;
}

function CurrentProductDetailsPage() {
  return getCurrentDashboard() === "warehouse"
    ? <WarehouseProductDetailsPage />
    : <ProductDetailsPage />;
}

function CurrentInventoryPage() {
  return getCurrentDashboard() === "warehouse" ? <WarehouseInventory /> : <AdminInventory />;
}

function CurrentNotificationsPage() {
  return getCurrentDashboard() === "warehouse" ? (
    <WarehouseNotificationsPage />
  ) : (
    <NotificationsPage />
  );
}

function CurrentInventoryDetailsPage() {
  return getCurrentDashboard() === "warehouse"
    ? <InventoryProductDetailsPage />
    : <ProductDetailsPage />;
}

function CurrentPaymentCollectionsPage() {
  return getCurrentDashboard() === "warehouse"
    ? <PaymentCollectionsPage scope="warehouse" />
    : <PaymentCollectionsPage scope="admin" />;
}

function RequireEmail({ children }) {
  const flow = getAuthFlow();
  if (!flow?.resetEmail) return <Navigate to="/admin/forgot-password" replace />;
  return children;
}

function RequireOtp({ children }) {
  const flow = getAuthFlow();
  if (!flow?.resetEmail) return <Navigate to="/admin/forgot-password" replace />;
  if (!flow?.otpVerified) return <Navigate to="/admin/otp" replace />;
  return children;
}

function RequireAuth({ children }) {
  const token = getAuthToken();

  if (!token) return <Navigate to="/admin/login" replace />;

  if (!isAuthSessionValid()) {
    clearAllAuthState();
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}

function routeFromNextAction(input) {
  const nextAction = typeof input === "string" ? input : null;
  const admin = typeof input === "object" && input ? input : null;

  if (!nextAction && !admin) {
    return "/admin/login";
  }

  if (nextAction) {
    switch (String(nextAction || "").toUpperCase()) {
      case "CHANGE_PASSWORD":
      case "CHANGE_PASSWORD_REQUIRED":
        return "/admin/change-password";

      case "ONBOARDING":
      case "ONBOARDING_REQUIRED":
      case "ONBOARDING_REJECTED":
      case "REJECTED":
        return "/admin/onboarding";

      case "WAITING_APPROVAL":
      case "WAITING_FOR_ADMIN_APPROVAL":
        return "/admin/waiting-approval";

      default:
        return "/admin/dashboard";
    }
  }

  if (admin?.mustChangePassword) return "/admin/change-password";
  if (admin?.isOnboardingComplete === false) return "/admin/onboarding";

  const approvalStatus = String(admin?.approvalStatus || "").toUpperCase();
  if (approvalStatus === "PENDING") return "/admin/waiting-approval";
  if (approvalStatus === "REJECTED") return "/admin/onboarding";

  return "/admin/dashboard";
}

function PublicOnly({ children }) {
  const token = getAuthToken();

  if (!token) return children;

  if (!isAuthSessionValid()) {
    clearAllAuthState();
    return children;
  }

  const admin = getAuthUser();
  return <Navigate to={routeFromNextAction(admin)} replace />;
}

function RequireAdminDashboard({ children }) {
  const token = getAuthToken();

  if (!token) return <Navigate to="/admin/login" replace />;

  if (!isAuthSessionValid()) {
    clearAllAuthState();
    return <Navigate to="/admin/login" replace />;
  }

  const dashboardAccess = getDashboardAccess();

  const canOpenAdmin = !!dashboardAccess?.canOpenAdminDashboard;
  const canOpenWarehouse = !!dashboardAccess?.canOpenWarehouseDashboard;

  if (!canOpenAdmin && !canOpenWarehouse) {
    clearAllAuthState();
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}

function RequirePagePermission({ anyOf = [], children }) {
  if (!Array.isArray(anyOf) || anyOf.length === 0) return children;

  const admin = getAuthUser();
  const role = String(admin?.role || "").toLowerCase();

  if (role === "super_admin") return children;

  const ok = hasPermission(anyOf);
  if (!ok) return <Navigate to="/admin/dashboard" replace />;
  return children;
}

function RequireAdminUsersAccess({ children }) {
  const admin = getAuthUser();
  const role = String(admin?.role || "").toLowerCase();
  if (role !== "super_admin" && role !== "admin") {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
}

function RequireSupportAccess({ children }) {
  const admin = getAuthUser();
  const role = String(admin?.role || "").toLowerCase();
  const allowed =
    role === "super_admin" ||
    role === "admin" ||
    hasPermission("admin.support");

  if (!allowed) return <Navigate to="/admin/dashboard" replace />;
  return children;
}
function CurrentStockPage() {
  return getCurrentDashboard() === "warehouse" ? <WarehouseStockPage /> : <AdminStockPage />;
}


export default function AppRoutes() {
  const [, setAuthRenderTick] = useState(0);

  useEffect(() => {
    const rerender = () => setAuthRenderTick((v) => v + 1);

    window.addEventListener(AUTH_STATE_EVENT, rerender);
    window.addEventListener("storage", rerender);

    return () => {
      window.removeEventListener(AUTH_STATE_EVENT, rerender);
      window.removeEventListener("storage", rerender);
    };
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/admin/login" replace />} />

      <Route
        path="/admin/login"
        element={
          <PublicOnly>
            <Login />
          </PublicOnly>
        }
      />

      <Route
        path="/admin/forgot-password"
        element={
          <PublicOnly>
            <ForgotPassword />
          </PublicOnly>
        }
      />

      <Route
        path="/admin/otp"
        element={
          <RequireEmail>
            <PublicOnly>
              <OtpVerify />
            </PublicOnly>
          </RequireEmail>
        }
      />

      <Route
        path="/admin/reset-password"
        element={
          <RequireOtp>
            <PublicOnly>
              <ResetPassword />
            </PublicOnly>
          </RequireOtp>
        }
      />

      <Route
        path="/admin/change-password"
        element={
          <RequireAuth>
            <ChangeTemporaryPassword />
          </RequireAuth>
        }
      />

      <Route
        path="/admin/onboarding"
        element={
          <RequireAuth>
            <EmployeeOnboarding />
          </RequireAuth>
        }
      />

      <Route
        path="/admin/waiting-approval"
        element={
          <RequireAuth>
            <WaitingApproval />
          </RequireAuth>
        }
      />

      <Route
        path="/admin/approval-rejected"
        element={
          <RequireAuth>
            <ApprovalRejected />
          </RequireAuth>
        }
      />

      <Route
        path="/admin/dashboard"
        element={
          <RequireAdminDashboard>
            <CurrentDashboardLayout />
          </RequireAdminDashboard>
        }
      >
        <Route index element={<CurrentDashboardHome />} />
        <Route path="profile" element={<Profile />} />
        <Route path="notifications" element={<CurrentNotificationsPage />} />

        <Route
          path="activity-logs"
          element={<ActivityLogsPage />}
        />

        <Route
          path="roles"
          element={
            <RequirePagePermission anyOf={["rbac.roles.read"]}>
              <ManageRoles />
            </RequirePagePermission>
          }
        />



        <Route
          path="roles/new"
          element={
            <RequirePagePermission anyOf={["rbac.roles.create"]}>
              <AddNewRole />
            </RequirePagePermission>
          }
        />

        <Route
          path="roles/:id/edit"
          element={
            <RequirePagePermission anyOf={["rbac.roles.read", "rbac.roles.create"]}>
              <AddNewRole />
            </RequirePagePermission>
          }
        />

        <Route
          path="employees"
          element={
            <RequirePagePermission anyOf={["employees.view", "admin.employees.read", "warehouse.employees.read", "warehouse_employee.read"]}>
              <CurrentEmployeesPage />
            </RequirePagePermission>
          }
        />

        <Route
          path="employees/new"
          element={
            <RequirePagePermission anyOf={["employees.create", "admin.employees.create"]}>
              <AddNewEmployee />
            </RequirePagePermission>
          }
        />

        <Route
          path="employees/:id/edit"
          element={
            <RequirePagePermission anyOf={["employees.update", "admin.employees.update"]}>
              <AddNewEmployee />
            </RequirePagePermission>
          }
        />

        <Route
          path="employees/:id"
          element={
            <RequirePagePermission anyOf={["employees.view", "admin.employees.read", "warehouse.employees.read", "warehouse_employee.read", "wh.employees.read"]}>
              <EmployeeProfile />
            </RequirePagePermission>
          }
        />


        <Route
          path="users"
          element={
            <RequireAdminUsersAccess>
              <UserDetails />
            </RequireAdminUsersAccess>
          }
        />

        <Route
          path="users/:id"
          element={
            <RequireAdminUsersAccess>
              <UserForm mode="view" />
            </RequireAdminUsersAccess>
          }
        />

        <Route
          path="users/:id/edit"
          element={
            <RequireAdminUsersAccess>
              <UserForm mode="edit" />
            </RequireAdminUsersAccess>
          }
        />

        <Route
          path="warehouse"
          element={
            <RequirePagePermission anyOf={["warehouses.view", "admin.warehouses.read"]}>
              <WarehouseDetails />
            </RequirePagePermission>
          }
        />

        <Route
          path="warehouse/new"
          element={
            <RequirePagePermission anyOf={["warehouses.create", "admin.warehouses.create"]}>
              <AddNewWarehouse />
            </RequirePagePermission>
          }
        />

        <Route
          path="warehouse/:id"
          element={
            <RequirePagePermission anyOf={["warehouses.view", "admin.warehouses.read"]}>
              <WarehouseView />
            </RequirePagePermission>
          }
        />

        <Route
          path="products"
          element={
            <RequirePagePermission
              anyOf={[
                "products.view",
                "admin.products.read",
                "admin.catalog.read",
                "admin.catalog.manage",
                "warehouse.products.read",
                "wh.products.read",
              ]}
            >
              <CurrentProductsPage />
            </RequirePagePermission>
          }
        />

        <Route
          path="app-layout"
          element={
            <RequirePagePermission anyOf={["admin.app_layout.read", "admin.app_layout.manage"]}>
              <AppLayoutManager />
            </RequirePagePermission>
          }
        />

        <Route
          path="products/new"
          element={
            <RequirePagePermission anyOf={["products.create", "admin.catalog.manage"]}>
              <AddProduct />
            </RequirePagePermission>
          }
        />

        <Route
          path="products/:id"
          element={
            <RequirePagePermission
              anyOf={[
                "products.view",
                "admin.products.read",
                "admin.catalog.read",
                "admin.catalog.manage",
                "warehouse.products.read",
                "wh.products.read",
              ]}
            >
              <CurrentProductDetailsPage />
            </RequirePagePermission>
          }
        />

        <Route
          path="products/:id/edit"
          element={
            <RequirePagePermission anyOf={["products.update", "admin.catalog.manage"]}>
              <AddProduct />
            </RequirePagePermission>
          }
        />

        <Route
          path="pricing"
          element={
            <RequirePagePermission
              anyOf={[
                "products.view",
                "admin.products.read",
                "admin.catalog.read",
                "admin.catalog.manage",
                "warehouse.products.read",
                "wh.products.read",
              ]}
            >
              <AdminPricing />
            </RequirePagePermission>
          }
        />

        <Route
          path="inventory/purchase-history"
          element={
            <RequirePagePermission
              anyOf={[
                "products.view",
                "admin.products.read",
                "admin.catalog.read",
                "admin.catalog.manage",
              ]}
            >
              <PurchaseHistoryPage />
            </RequirePagePermission>
          }
        />

        <Route
          path="support"
          element={
            <RequireSupportAccess>
              <SupportInbox />
            </RequireSupportAccess>
          }
        />

        <Route path="order-analytics" element={<Navigate to="/admin/dashboard/reports" replace />} />

        <Route
          path="reports"
          element={
            <RequirePagePermission anyOf={["admin.reports.read", "admin.reports.export"]}>
              <ReportsDashboard />
            </RequirePagePermission>
          }
        />


        <Route
          path="posters"
          element={
            <RequirePagePermission anyOf={["admin.posters.read", "admin.posters.manage"]}>
              <PostersPage />
            </RequirePagePermission>
          }
        />

        <Route
          path="short-videos"
          element={
            <RequirePagePermission anyOf={["admin.short_videos.read", "admin.short_videos.manage"]}>
              <ShortVideosPage />
            </RequirePagePermission>
          }
        />

        <Route
          path="broadcast-messages"
          element={
            <RequirePagePermission anyOf={["admin.broadcasts.read", "admin.broadcasts.manage"]}>
              <BroadcastMessagesPage />
            </RequirePagePermission>
          }
        />

        <Route
          path="coupons"
          element={
            <RequirePagePermission anyOf={["admin.coupons.read", "admin.coupons.manage", "wh.coupons.read", "wh.coupons.create", "wh.orders.create", "warehouse.panel.access"]}>
              <CouponsPage />
            </RequirePagePermission>
          }
        />

        <Route
          path="user-notifications"
          element={
            <RequireAdminUsersAccess>
              <UserNotificationsPage />
            </RequireAdminUsersAccess>
          }
        />

        <Route
          path="settings"
          element={
            <RequirePagePermission
              anyOf={[
                "admin.settings.read",
                "admin.settings.update",
              ]}
            >
              <SettingsPage />
            </RequirePagePermission>
          }
        />



        <Route
          path="inventory"
          element={
            <RequirePagePermission
              anyOf={[
                "inventory.view",
                "inventory.read",
                "admin.inventory.read",
                "warehouse.inventory.read",
                "warehouse.stock.read",
                "wh.inventory.read",
                "wh.orders.read",
                "wh.orders.create",
                "wh.inbound.read",
                "wh.inbound.accept",
              ]}
            >
              <CurrentInventoryPage />
            </RequirePagePermission>
          }
        />

        <Route
          path="stock"
          element={
            <RequirePagePermission
              anyOf={[
                "inventory.view",
                "inventory.read",
                "admin.inventory.read",
                "warehouse.inventory.read",
                "warehouse.stock.read",
                "wh.inventory.read",
              ]}
            >
              <CurrentStockPage />
            </RequirePagePermission>
          }
        />

        <Route
          path="inbound-receipts"
          element={
            <RequirePagePermission
              anyOf={[
                "inventory.view",
                "inventory.read",
                "admin.inventory.read",
                "warehouse.inventory.read",
                "wh.inbound.read",
                "wh.inbound.accept",
              ]}
            >
              <WarehouseInboundReceiptsPage />
            </RequirePagePermission>
          }
        />

        <Route
          path="inventory/:id"
          element={
            <RequirePagePermission
              anyOf={[
                "inventory.view",
                "inventory.read",
                "admin.inventory.read",
                "warehouse.inventory.read",
                "warehouse.stock.read",
                "wh.inventory.read",
                "wh.orders.read",
                "wh.orders.create",
                "wh.inbound.read",
                "wh.inbound.accept",
                "products.view",
                "admin.products.read",
                "admin.catalog.read",
                "admin.catalog.manage",
                "warehouse.products.read",
                "wh.products.read",
              ]}
            >
              <CurrentInventoryDetailsPage />
            </RequirePagePermission>
          }
        />

        <Route
          path="payment-collections"
          element={
            <RequirePagePermission
              anyOf={["admin.payment_collections.read", "wh.payments.read"]}
            >
              <CurrentPaymentCollectionsPage />
            </RequirePagePermission>
          }
        />

        <Route
          path="warehouse-sales"
          element={
            getCurrentDashboard() === "warehouse" ? (
              <RequirePagePermission anyOf={["wh.orders.read", "warehouse.orders.read", "orders.view", "orders.read"]}>
                <WarehouseSalesAnalytics />
              </RequirePagePermission>
            ) : (
              <Navigate to="/admin/dashboard/reports" replace />
            )
          }
        />

        <Route
          path="customer-orders"
          element={
            <WarehouseCustomerOrders />
          }
        />

        <Route
          path="catalog-import"
          element={
            <RequirePagePermission anyOf={["products.create", "products.update", "inventory.manage", "catalog.import", "admin.catalog.manage"]}>
              <AdminCatalogImport />
            </RequirePagePermission>
          }
        />

         <Route                                                   
          path="image-manager"
          element={
            <RequirePagePermission
              anyOf={["admin.catalog.read", "admin.catalog.manage"]}
            >
              <ImageManagerPage />
            </RequirePagePermission>
          }
        /> 

        <Route
          path="driver-wallet"
          element={
            <RequirePagePermission anyOf={["admin.driver_wallet.read", "admin.driver_wallet.manage"]}>
              <DriverWalletPage />
            </RequirePagePermission>
          }
        />

        <Route
          path="delivery-partners"
          element={
            <RequirePagePermission anyOf={["delivery.partners.read", "admin.delivery_partners.read"]}>
              <DeliveryPartners />
            </RequirePagePermission>
          }
        />

        <Route
          path="delivery-partners/:id"
          element={
            <RequirePagePermission anyOf={["delivery.partners.read", "admin.delivery_partners.read"]}>
              <DeliveryPartnerProfile />
            </RequirePagePermission>
          }
        />

        <Route
          path="email-templates"
          element={
            <RequirePagePermission anyOf={["admin.email_templates.read", "email.templates.read", "settings.email_templates.read"]}>
              <EmailTemplates />
            </RequirePagePermission>
          }
        />
      </Route>

      <Route
        path="/admin/food-dashboard"
        element={
          <RequireAdminDashboard>
            <FoodAdminLayout />
          </RequireAdminDashboard>
        }
      >
        <Route index element={<FoodOverview />} />
        <Route path="profile" element={<Navigate to="/admin/dashboard/profile" replace />} />
        <Route path="notifications" element={<FoodNotificationsPage />} />
        <Route path="food-items" element={<Navigate to="/admin/food-dashboard/items" replace />} />
        <Route path="food-master" element={<Navigate to="/admin/food-dashboard/items" replace />} />
        <Route path="restaurants" element={<FoodRestaurantsPage />} />
        <Route path="restaurants/:id" element={<FoodRestaurantDetailsPage />} />
        <Route path="employees" element={<FoodEmployeesPage />} />
        <Route path="items" element={<FoodItemsPage />} />
        <Route path="items/new" element={<FoodAddItem />} />
        <Route path="items/:id/edit" element={<FoodAddItem />} />
        <Route path="items/:id" element={<FoodItemDetailsPage />} />
        <Route path="import" element={<Navigate to="/admin/food-dashboard/items" replace />} />
        <Route path="approvals" element={<FoodApprovalsPage />} />
        <Route path="orders" element={<FoodOrdersPage />} />
        <Route path="coupons" element={<FoodCouponsPage />} />
        <Route path="reports" element={<FoodReportsPage />} />
        <Route path="settings" element={<FoodSettingsPage />} />
      </Route>

      <Route
        path="/admin/select-dashboard"
        element={
          <RequireAuth>
            <RequireAdminDashboard>
              <SelectDashboard />
            </RequireAdminDashboard>
          </RequireAuth>
        }
      />

      <Route path="*" element={<Navigate to="/admin/login" replace />} />
    </Routes>
  );
}
